<main>
  <ng-template #notShow>
    <hyperkit-typography
      display="block"
      variant="body"
      align="left"
      color="primary"
      >--</hyperkit-typography
    >
  </ng-template>
  <div class="container">
    <div class="row">
      <aside class="col-lg-3 left">
        <ul class="sidebar">
          <hyperkit-typography
            display="block"
            class="profile-name"
            variant="h3"
            align="left"
            color="primary"
            >Hunt Package</hyperkit-typography
          >
          @if (environments && environments?.length > 0) {
            <li>
              <hyperkit-link
                (click)="scrollTo('environment-content')"
                variant="body"
                size="sm"
                color="primary"
                text="My Environment"
              >
              </hyperkit-link>
            </li>
          }
          @if (huntContent.length > 0) {
            <li>
              <hyperkit-link
                (click)="scrollTo('hunt-content')"
                variant="body"
                size="sm"
                color="primary"
                text="Hunt Queries"
              >
              </hyperkit-link>
            </li>
          }
          @if (detectionContent.length > 0) {
            <li>
              <hyperkit-link
                (click)="scrollTo('detection-content')"
                variant="body"
                size="sm"
                color="primary"
                text="Detection Rules"
              >
              </hyperkit-link>
            </li>
          }
          @if (
            (relatedHunts$ | async)?.length > 0 && (relatedHunts$ | async);
            as related
          ) {
            <li>
              <hyperkit-link
                (click)="scrollTo('related-hunts')"
                variant="body"
                size="sm"
                color="primary"
                text="Related Hunts"
              >
              </hyperkit-link>
            </li>
          }
          <li>
            <hyperkit-link
              (click)="scrollTo('overview')"
              variant="body"
              size="sm"
              color="primary"
              text="Overview"
            >
            </hyperkit-link>
          </li>

          <li>
            <ul class="sub">
              <li>
                <hyperkit-link
                  (click)="scrollTo('description')"
                  variant="body"
                  size="sm"
                  color="primary"
                  text="Description"
                >
                </hyperkit-link>
              </li>
            </ul>
          </li>
          @if (data?.validation) {
            <li>
              <hyperkit-link
                (click)="scrollTo('emulationAndValidation')"
                variant="body"
                size="sm"
                color="primary"
                text="Emulation and Validation"
              >
              </hyperkit-link>
            </li>
          }
          @if (queryLogicData?.length > 0) {
            <li>
              <hyperkit-link
                (click)="scrollTo('queryLogic')"
                variant="body"
                size="sm"
                color="primary"
                text="Query Logic"
              >
              </hyperkit-link>
            </li>
          }
          <li>
            <hyperkit-link
              (click)="scrollTo('research')"
              variant="body"
              size="sm"
              color="primary"
              text="Research"
            >
            </hyperkit-link>
          </li>

          <li>
            <ul class="sub">
              <li>
                <hyperkit-link
                  (click)="scrollTo('analystNotes')"
                  variant="body"
                  size="sm"
                  color="primary"
                  text="Analyst Notes"
                >
                </hyperkit-link>
              </li>
              <li>
                <hyperkit-link
                  (click)="scrollTo('threatDescription')"
                  variant="body"
                  size="sm"
                  color="primary"
                  text="Threat Description"
                >
                </hyperkit-link>
              </li>
            </ul>
          </li>
          <li>
            <hyperkit-link
              (click)="scrollTo('references')"
              variant="body"
              size="sm"
              color="primary"
              text="References"
            >
            </hyperkit-link>
          </li>
          <li>
            <hyperkit-link
              (click)="scrollTo('mitre')"
              variant="body"
              size="sm"
              color="primary"
              text="MITRE Information"
            >
            </hyperkit-link>
          </li>
          <li>
            <hyperkit-link
              (click)="scrollTo('response')"
              variant="body"
              size="sm"
              color="primary"
              text="Response Actions"
            >
            </hyperkit-link>
          </li>
          <li>
            <ul class="sub">
              <li>
                <hyperkit-link
                  (click)="scrollTo('analystRunbook')"
                  variant="body"
                  size="sm"
                  color="primary"
                  text="Analyst Runbook"
                >
                </hyperkit-link>
              </li>
              <li>
                <hyperkit-link
                  (click)="scrollTo('mitigationRecommendations')"
                  variant="body"
                  size="sm"
                  color="primary"
                  text="Mitigation Recommendations"
                >
                </hyperkit-link>
              </li>
            </ul>
          </li>
        </ul>
      </aside>
      <div class="sections col-lg-9">
        <div class="title-row mx-0">
          <hyperkit-typography
            class="package-name"
            variant="h1"
            align="left"
            color="primary"
            >{{ data?.title }}</hyperkit-typography
          >
          <div class="title-options">
            @if (favorited) {
              <i
                class="k-icon k-font-icon k-i-bookmark favorite k-color-primary"
                (click)="unfavorite()"
              ></i>
            }
            @if (!favorited) {
              <i
                class="k-icon k-font-icon k-i-bookmark-outline favorite k-color-primary"
                (click)="favorite()"
              ></i>
            }
            <hyperkit-button
              size="small"
              color="secondary"
              text="Feedback"
              (click)="onFeedback()"
            ></hyperkit-button>
          </div>
        </div>
        @if (locked$ | async) {
          @if (relatedCollections$ | async; as collections) {
            @if (collections.length > 0) {
              <div class="row premium-ad" (click)="openPremiumDialog()">
                <img
                  width="16"
                  height="16"
                  src="/assets/img/icons/cyborg-premium.png"
                />
                <p>
                  Access all hunt packages in the
                  {{ collections[0].title }} collection
                  @if (collections.length > 1) {
                    <span
                      >and {{ collections.length - 1 }} more collections
                    </span>
                  }
                  with Hunter Premium
                </p>
              </div>
            }
          }
        }

        <cyborg-section
          [ngClass]="{ 'is-closed': isEnvContentClosed }"
          id="environment-content"
        >
          <cyborg-section-title>
            <div class="logo">
              <hyperkit-typography variant="h3" align="left" color="primary"
                >My Environment</hyperkit-typography
              >
            </div>
            <i
              class="k-icon k-font-icon k-i-arrow-chevron-down"
              (click)="onEnvContentClose()"
            ></i>
          </cyborg-section-title>

          <div class="row">
            <div class="col-12 env-filters">
              <form [formGroup]="contentForm">
                <div style="display: flex" class="row">
                  <div class="col-3">
                    <hyperkit-multiselect
                      label="Environments"
                      [options]="environments"
                      displayProperty="name"
                      formControlName="environments"
                      valueProperty="id"
                      (selectionChange)="filterContent()"
                    >
                    </hyperkit-multiselect>
                  </div>
                  <div class="col-3">
                    <hyperkit-multiselect
                      label="Tools"
                      [options]="tools"
                      formControlName="tools"
                      (selectionChange)="filterContent()"
                    >
                    </hyperkit-multiselect>
                  </div>
                  <div class="col-3">
                    <hyperkit-multiselect
                      label="Categories"
                      [options]="categories"
                      formControlName="categories"
                      (selectionChange)="filterContent()"
                    >
                    </hyperkit-multiselect>
                  </div>
                  <div class="col-3">
                    <hyperkit-button
                      size="small"
                      (click)="clearAllFilters()"
                      variant="link"
                      color="primary"
                      text="Clear all filters"
                    ></hyperkit-button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="row">
            @for (environment of environmentContent; track environment) {
              <cyborg-environment-content [environment]="environment">
              </cyborg-environment-content>
            }
          </div>
          <div class="row">
            @if (environments?.length === 0) {
              <hyperkit-message
                text="No environments to display. Create an environment to get started."
                type="warning"
                actionText="Configure"
                [closable]="false"
                (click)="goToEnvironmentSettings()"
              ></hyperkit-message>
            }
          </div>
        </cyborg-section>

        @if (huntContent.length > 0) {
          <cyborg-section
            [ngClass]="{ 'is-closed': isHuntContentClosed }"
            id="hunt-content"
          >
            <cyborg-section-title>
              <hyperkit-typography variant="h3" align="left" color="primary"
                >Hunt Queries</hyperkit-typography
              >
              <div>
                @if (huntCompatible) {
                  <span>
                    @if (huntModuleAccess) {
                      <hyperkit-button-menu
                        variant="standard"
                        iconPosition="right"
                        color="secondary"
                        size="small"
                        icon="chevron-down"
                        (itemSelected)="handleMenuAction($event)"
                        text="Hunt"
                      >
                        @for (option of newOptions; track option) {
                          <hyperkit-dropdown-menu-item
                            value="{{ option }}"
                            label="{{ option }}"
                          ></hyperkit-dropdown-menu-item>
                        }
                      </hyperkit-button-menu>
                    } @else {
                      <hyperkit-button
                        (click)="openHuntDialog()"
                        size="small"
                        text="Hunt"
                        color="secondary"
                        [customImage]="'/assets/img/icons/cyborg-premium.png'"
                      ></hyperkit-button>
                    }
                  </span>
                }
                <i
                  class="k-icon k-font-icon k-i-arrow-chevron-down"
                  (click)="onHuntContentClose()"
                ></i>
              </div>
            </cyborg-section-title>
            <div class="row">
              @for (content of huntContent; track content) {
                <cyborg-content
                  [content]="content"
                  [huntPackage]="data"
                  type="hunt-package"
                >
                </cyborg-content>
              }
            </div>
          </cyborg-section>
        }
        @if (detectionContent.length > 0) {
          <cyborg-section
            [ngClass]="{ 'is-closed': isDetectionContentClosed }"
            id="detection-content"
          >
            <cyborg-section-title>
              <hyperkit-typography variant="h3" align="left" color="primary"
                >Detection Rules</hyperkit-typography
              >
              <div class="detection-actions">
                @if (deployStatus && deployStatus === 'notDeployed') {
                  <hyperkit-button
                    size="small"
                    color="tertiary"
                    text="Stage for Deploy"
                    (click)="markAsStaged(huntPackageUUID)"
                  ></hyperkit-button>
                  <hyperkit-button
                    size="small"
                    color="tertiary"
                    text="Mark as Deployed"
                    (click)="markAsDeployed(huntPackageUUID)"
                  ></hyperkit-button>
                }
                @if (deployStatus && deployStatus === 'staged') {
                  <hyperkit-button
                    size="small"
                    color="secondary"
                    text="Unstage"
                    (click)="removeDeployed(huntPackageUUID)"
                  ></hyperkit-button>
                  <hyperkit-button
                    size="small"
                    color="tertiary"
                    text="Mark as Deployed"
                    (click)="markAsDeployed(huntPackageUUID)"
                  ></hyperkit-button>
                }
                @if (deployStatus && deployStatus === 'deployed') {
                  <hyperkit-button
                    size="small"
                    color="secondary"
                    text="Remove From Deployed"
                    (click)="removeDeployed(huntPackageUUID)"
                  ></hyperkit-button>
                }
                @if (deployStatus && deployStatus === 'outdated') {
                  <hyperkit-button
                    size="small"
                    color="tertiary"
                    text="Re-Deploy"
                    (click)="markAsDeployed(huntPackageUUID)"
                  ></hyperkit-button>
                }
                <i
                  class="k-icon k-font-icon k-i-arrow-chevron-down"
                  (click)="onDetectionContentClose()"
                ></i>
              </div>
            </cyborg-section-title>
            <div class="row">
              @for (content of detectionContent; track content) {
                <cyborg-content
                  [content]="content"
                  [huntPackage]="data"
                  type="hunt-package"
                >
                </cyborg-content>
              }
            </div>
          </cyborg-section>
        }
        @if (
          (relatedHunts$ | async)?.length > 0 && (relatedHunts$ | async);
          as related
        ) {
          <cyborg-section id="related-hunts">
            <cyborg-section-title>
              <hyperkit-typography variant="h3" align="left" color="primary"
                >Related Hunts</hyperkit-typography
              >
            </cyborg-section-title>
            <div class="related-wrapper">
              @for (
                hunt of showAll ? related : related.slice(0, 5);
                track hunt
              ) {
                <div class="py-3 related-hunts">
                  <hyperkit-link
                    routerLink="/hunt/{{ hunt.id }}"
                    class="link"
                    display="inline"
                    variant="emphasized"
                    size="sm"
                    align="left"
                    color="primary"
                    text="{{ hunt.name }}"
                  ></hyperkit-link>
                  <div class="badges">
                    <hyperkit-badge
                      [variant]="hunt.priority | priorityBadge"
                      [text]="hunt.priority"
                    ></hyperkit-badge>
                    <hyperkit-badge
                      [variant]="hunt.status | statusBadge"
                      [text]="hunt.status"
                    ></hyperkit-badge>
                    @if (hunt.outcome) {
                      <hyperkit-badge
                        [variant]="hunt.outcome | outcomeBadge"
                        [text]="hunt.outcome"
                      ></hyperkit-badge>
                    }
                  </div>
                </div>
              }
            </div>
            @if (related && related.length > 5) {
              <hyperkit-link
                class="pt-5 show"
                variant="emphasized"
                size="sm"
                color="primary"
                display="inline"
                [text]="showAll ? 'Show less...' : 'Show more...'"
                (click)="toggleShowAll()"
              ></hyperkit-link>
            }
          </cyborg-section>
        }
        <cyborg-section id="overview">
          <cyborg-section-title>
            <hyperkit-typography variant="h3" align="left" color="primary"
              >Overview</hyperkit-typography
            >
          </cyborg-section-title>
          <div class="section-body">
            <cyborg-hunt-package-overview
              [data]="data"
            ></cyborg-hunt-package-overview>
          </div>
        </cyborg-section>
        <cyborg-section id="emulationAndValidation">
          <cyborg-section-title>
            <hyperkit-typography variant="h3" align="left" color="primary"
              >Emulation and Validation</hyperkit-typography
            >
          </cyborg-section-title>
          <cyborg-content-section>
            <hyperkit-typography
              class="emulation"
              variant="body"
              size="md"
              align="left"
              color="body"
              >{{ data?.validation }}</hyperkit-typography
            >
            <div class="row justify-content-center">
              @if (
                data?.validation_types &&
                data?.validation_types.length > 0 &&
                !data?.validation_types.includes('manual')
              ) {
                <hyperkit-button
                  icon="plus"
                  size="small"
                  color="tertiary"
                  text="Download Validation Package"
                  (click)="downloadValidation(data?.title)"
                ></hyperkit-button>
              }
            </div>
          </cyborg-content-section>
        </cyborg-section>
        <cyborg-section id="queryLogic">
          <cyborg-section-title>
            <div class="logo">
              <div>
                <hyperkit-typography
                  display="inline"
                  variant="h3"
                  align="left"
                  color="primary"
                  >Query Logic</hyperkit-typography
                >
                <hyperkit-tooltip
                  [text]="queryLogicTooltipText"
                  position="top"
                  id="tooltip"
                >
                  <hyperkit-icon icon="info" size="medium"></hyperkit-icon>
                </hyperkit-tooltip>
              </div>
            </div>
          </cyborg-section-title>
          <div class="section-body">
            <cyborg-query-logic
              [queryLogic]="data?.query_logic"
            ></cyborg-query-logic>
          </div>
        </cyborg-section>
        <cyborg-section id="research">
          <cyborg-section-title>
            <hyperkit-typography variant="h3" align="left" color="primary"
              >Research</hyperkit-typography
            >
          </cyborg-section-title>
          <div class="section-body">
            <shared-analyst-notes
              id="analystNotes"
              [runningNotes]="data?.running_analyst_notes"
              [threatDescription]="data?.context?.threat_description"
            ></shared-analyst-notes>
          </div>
        </cyborg-section>
        <cyborg-section id="references">
          <cyborg-section-title>
            <hyperkit-typography variant="h3" align="left" color="primary"
              >References</hyperkit-typography
            >
          </cyborg-section-title>
          <div class="section-body">
            <shared-references
              [references]="data?.references"
            ></shared-references>
          </div>
        </cyborg-section>

        @if (data?.mapping?.mitre?.mitre_attack_tactics.length > 0) {
          <cyborg-section id="mitre">
            <cyborg-section-title>
              <hyperkit-typography variant="h3" align="left" color="primary">
                MITRE Information</hyperkit-typography
              >
            </cyborg-section-title>
            <div class="section-body">
              <shared-mitre-info
                [tactics]="data?.mapping?.mitre?.mitre_attack_tactics ?? []"
                [techniques]="
                  data?.mapping?.mitre?.mitre_attack_techniques ?? []
                "
                [techniqueIds]="
                  data?.mapping?.mitre?.mitre_attack_technique_ids ?? []
                "
              ></shared-mitre-info>
            </div>
          </cyborg-section>
        }
        <cyborg-section id="response">
          <cyborg-section-title>
            <hyperkit-typography variant="h3" align="left" color="primary">
              Response Actions</hyperkit-typography
            >
          </cyborg-section-title>
          <div class="section-body">
            <shared-response-actions
              [analystRunbook]="data?.response_actions?.analyst_runbook ?? ''"
              [mitigationRecommendations]="
                data?.response_actions?.mitigation_recommendations ?? ''
              "
              [playbook]="data?.response_actions?.playbook ?? ''"
            ></shared-response-actions>
          </div>
        </cyborg-section>
      </div>
    </div>
  </div>
</main>
<cyborg-modal-feedback
  id="feedback"
  class="modal"
  [huntPackageUUID]="huntPackageUUID"
></cyborg-modal-feedback>
<div kendoDialogContainer></div>
